export enum CarriedInterestDayCountFormat {
  ActualActual = 'ActualActual',
  Actual365 = 'Actual365',
  Actual360 = 'Actual360',
  Fixed30By365 = 'Fixed30by365',
  Fixed30By360 = 'Fixed30by360',
}

export enum CarriedInterestFeeAllocationMethod {
  CommitmentProRata = 'CommitmentProRata',
  InvestorSpecific = 'InvestorSpecific',
}

export enum WaterfallStructure {
  ReturnOfCapital = 'ReturnOfCapital',
  PreferredReturn = 'PreferredReturn',
  CarriedInterestPartnerCatchup = 'CarriedInterestPartnerCatchup',
  ExcessProceeds = 'ExcessProceeds',
}

export enum PreferredReturnAccrualMethod {
  Simple = 'Simple',
  Compound = 'Compound',
}

export enum PreferredReturnAccrualPeriod {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
}

export enum PreferredReturnCompoundingPeriod {
  Daily = 'Daily',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Yearly = 'Yearly',
}

export enum PreferredReturnCalculationEnd {
  UponFullReturnOfCapital = 'UponFullReturnOfCapital',
  UponFullReturnOfCapitalPlusAccruedPreferredReturn = 'UponFullReturnOfCapitalPlusAccruedPreferredReturn',
}

export enum PreferredReturnBasis {
  Drawn = 'Drawn',
}

export enum CapitalContributionType {
  FixedAmount = 'FixedAmount',
  PercentageOfTotalCapital = 'PercentageOfTotalCapital',
}

export interface CarriedInterestFeeTemplate {
  _id: string;
  name: string;
  carriedInterestRates: Array<{
    rate: number;
    dpiThreshold?: number | null;
  }>;
  carriedInterestPartnerCatchupBetweenRateThresholds: boolean;
  preferredReturnRate: number;
  preferredReturnAccrualMethod: PreferredReturnAccrualMethod;
  preferredReturnAccrualPeriod: PreferredReturnAccrualPeriod;
  preferredReturnCompoundingPeriod?: PreferredReturnCompoundingPeriod | null;
  preferredReturnCalculationEnd: PreferredReturnCalculationEnd;
  preferredReturnBasis: PreferredReturnBasis;
  partnerCatchupSpeed: number;
  isDefault?: boolean;
}
